// extracted by mini-css-extract-plugin
module.exports = {"modal":"style_modal__R3NKw","conversation":"style_conversation__FRhtu"};